// Nhãn + màu cho các loại chuyên cần (đồng bộ với app mobile)

export const ATTENDANCE_META = {
  CHECKIN_ON_TIME: { label: "Đúng giờ", bg: "#E9FFF1", color: "#18C758" },
  CHECKIN_LATE: { label: "Đi muộn", bg: "#EAF2FF", color: "#1277EB" },
  HALF_SHIFT: { label: "Nửa ca", bg: "#F5EFFF", color: "#8B5CF6" },
  REGISTER_OUTSIDE: { label: "Làm ngoài", bg: "#FFF4E6", color: "#F79D0D" },
  MAKEUP_WORK: { label: "Làm bù", bg: "#E6FAFF", color: "#10A7E2" },
  LEAVE: { label: "Nghỉ phép", bg: "#FFF0EA", color: "#EC5B2A" },
  ABSENT: { label: "Vắng mặt", bg: "#FFF0F6", color: "#E75A90" },
  HOLIDAY: { label: "Cuối tuần / Lễ", bg: "#FFECEC", color: "#F45757" },
  MISSING: { label: "Chưa chấm", bg: "#EAF2FF", color: "#64748B" },
};

export const attendanceMeta = (type) =>
  ATTENDANCE_META[type] || ATTENDANCE_META.MISSING;

// Nhãn "Phân loại" trong màn chi tiết (khớp typeLabel của app)
export const ATTENDANCE_TYPE_LABEL = {
  CHECKIN_ON_TIME: "Chấm công",
  CHECKIN_LATE: "Đi muộn",
  HALF_SHIFT: "Nửa ca",
  MAKEUP_WORK: "Đi làm bù",
  REGISTER_OUTSIDE: "Đi làm ngoài",
  ABSENT: "Vắng mặt",
  LEAVE: "Nghỉ phép",
  HOLIDAY: "Cuối tuần / Lễ",
};
export const typeLabel = (t) => (t ? ATTENDANCE_TYPE_LABEL[t] || "-" : "-");

// Nhãn trạng thái hiển thị trên card danh sách (khớp attendanceUiStyle của app)
export const ATTENDANCE_STATUS_TEXT = {
  CHECKIN_ON_TIME: "Đã chấm công",
  CHECKIN_LATE: "Đi muộn",
  HALF_SHIFT: "Nửa ca",
  REGISTER_OUTSIDE: "Làm ngoài",
  MAKEUP_WORK: "Làm bù",
  LEAVE: "Nghỉ phép",
  ABSENT: "Vắng mặt",
  HOLIDAY: "Cuối tuần / Lễ",
  MISSING: "Chưa chấm công",
};
export const attendanceStatusText = (t) =>
  ATTENDANCE_STATUS_TEXT[t] || ATTENDANCE_STATUS_TEXT.MISSING;

// Lấy địa điểm chấm công để hiển thị (khớp formatCheckInPlace của app)
export const formatCheckInPlace = (item) => {
  if (!item) return "-";
  const pick = (...vals) => {
    for (const v of vals) {
      if (typeof v === "string" && v.trim()) return v.trim();
    }
    return "";
  };
  const fromCheckins = () => {
    const checkins = Array.isArray(item.checkins) ? item.checkins : [];
    if (checkins.length) {
      const places = checkins
        .map((c) => pick(c?.checkinPlaceObject?.identifier, c?.checkinPlaceObject?.name))
        .filter(Boolean);
      const uniq = Array.from(new Set(places));
      if (uniq.length) return uniq.join("\n");
    }
    return (
      pick(
        item?.checkin?.checkinPlaceObject?.identifier,
        item?.checkin?.checkinPlaceObject?.name,
        item?.checkinPlaceObject?.identifier,
        item?.checkinPlaceObject?.name
      ) || "-"
    );
  };
  if (item.attendanceType === "REGISTER_OUTSIDE") {
    return (
      pick(
        item?.registerCheckin?.checkinPlace,
        item?.checkinPlaceObject?.identifier,
        item?.checkinPlaceObject?.name
      ) || "-"
    );
  }
  if (["CHECKIN_ON_TIME", "CHECKIN_LATE", "HALF_SHIFT"].includes(item.attendanceType)) {
    return fromCheckins();
  }
  return "-";
};

// Thứ tự legend hiển thị
export const ATTENDANCE_LEGEND_ORDER = [
  "CHECKIN_ON_TIME",
  "CHECKIN_LATE",
  "HALF_SHIFT",
  "REGISTER_OUTSIDE",
  "MAKEUP_WORK",
  "LEAVE",
  "ABSENT",
  "HOLIDAY",
  "MISSING",
];
